/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AccountClaimsResponseModel } from '../models';
// @ts-ignore
import type { AccountPatchModel } from '../models';
// @ts-ignore
import type { AccountSearch } from '../models';
// @ts-ignore
import type { ClaimSearch } from '../models';
// @ts-ignore
import type { GetAccounts200Response } from '../models';
// @ts-ignore
import type { GuarantorFhirModel } from '../models';
// @ts-ignore
import type { GuarantorRefundModel } from '../models';
// @ts-ignore
import type { GuarantorResponseModel } from '../models';
// @ts-ignore
import type { GuarantorSearch } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PostAccountResponseModel } from '../models';
// @ts-ignore
import type { SearchGuarantors200Response } from '../models';
/**
 * FHIRAccountApi - axios parameter creator
 * @export
 */
export const FHIRAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an account for primary claim filing
         * @summary Create an account for primary claim filing
         * @param {string} patientId 
         * @param {string} coverageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: async (patientId: string, coverageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('createAccount', 'patientId', patientId)
            // verify required parameter 'coverageId' is not null or undefined
            assertParamExists('createAccount', 'coverageId', coverageId)
            const localVarPath = `/api/v1/fhir/account/{patientId}/{coverageId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"coverageId"}}`, encodeURIComponent(String(coverageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a guarantor refund amount
         * @param {string} guarantorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGuarantorRefund: async (guarantorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'guarantorId' is not null or undefined
            assertParamExists('deleteGuarantorRefund', 'guarantorId', guarantorId)
            const localVarPath = `/api/v1/fhir/account/guarantor/{guarantorId}/refund`
                .replace(`{${"guarantorId"}}`, encodeURIComponent(String(guarantorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated accounts
         * @summary Get paginated accounts
         * @param {AccountSearch} accountSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: async (accountSearch: AccountSearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountSearch' is not null or undefined
            assertParamExists('getAccounts', 'accountSearch', accountSearch)
            const localVarPath = `/api/v1/fhir/account/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get account by a patient
         * @summary Get account by a patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsByPatient: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getAccountsByPatient', 'patientId', patientId)
            const localVarPath = `/api/v1/fhir/account/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * paginated data for claims for an account
         * @summary Get paginated claims for an account
         * @param {string} accountId 
         * @param {ClaimSearch} claimSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimsByAccount: async (accountId: string, claimSearch: ClaimSearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getClaimsByAccount', 'accountId', accountId)
            // verify required parameter 'claimSearch' is not null or undefined
            assertParamExists('getClaimsByAccount', 'claimSearch', claimSearch)
            const localVarPath = `/api/v1/fhir/account/{accountId}/claims`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get guarantor info on the basis of guarantor ID
         * @param {string} guarantorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuarantor: async (guarantorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'guarantorId' is not null or undefined
            assertParamExists('getGuarantor', 'guarantorId', guarantorId)
            const localVarPath = `/api/v1/fhir/account/guarantor/{guarantorId}`
                .replace(`{${"guarantorId"}}`, encodeURIComponent(String(guarantorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch an account
         * @summary Patch an account
         * @param {string} accountId 
         * @param {AccountPatchModel} accountPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccount: async (accountId: string, accountPatchModel: AccountPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('patchAccount', 'accountId', accountId)
            // verify required parameter 'accountPatchModel' is not null or undefined
            assertParamExists('patchAccount', 'accountPatchModel', accountPatchModel)
            const localVarPath = `/api/v1/fhir/account/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch a Guarantor
         * @param {string} guarantorId 
         * @param {GuarantorFhirModel} guarantorFhirModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGuarantor: async (guarantorId: string, guarantorFhirModel: GuarantorFhirModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'guarantorId' is not null or undefined
            assertParamExists('patchGuarantor', 'guarantorId', guarantorId)
            // verify required parameter 'guarantorFhirModel' is not null or undefined
            assertParamExists('patchGuarantor', 'guarantorFhirModel', guarantorFhirModel)
            const localVarPath = `/api/v1/fhir/account/guarantor/{guarantorId}`
                .replace(`{${"guarantorId"}}`, encodeURIComponent(String(guarantorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guarantorFhirModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post a guarantor refund unallocated amount
         * @param {string} guarantorId 
         * @param {GuarantorRefundModel} guarantorRefundModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGuarantorRefund: async (guarantorId: string, guarantorRefundModel: GuarantorRefundModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'guarantorId' is not null or undefined
            assertParamExists('postGuarantorRefund', 'guarantorId', guarantorId)
            // verify required parameter 'guarantorRefundModel' is not null or undefined
            assertParamExists('postGuarantorRefund', 'guarantorRefundModel', guarantorRefundModel)
            const localVarPath = `/api/v1/fhir/account/guarantor/{guarantorId}/refund`
                .replace(`{${"guarantorId"}}`, encodeURIComponent(String(guarantorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guarantorRefundModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search a Guarantor
         * @param {GuarantorSearch} guarantorSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGuarantors: async (guarantorSearch: GuarantorSearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'guarantorSearch' is not null or undefined
            assertParamExists('searchGuarantors', 'guarantorSearch', guarantorSearch)
            const localVarPath = `/api/v1/fhir/account/guarantor/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guarantorSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FHIRAccountApi - functional programming interface
 * @export
 */
export const FHIRAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FHIRAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an account for primary claim filing
         * @summary Create an account for primary claim filing
         * @param {string} patientId 
         * @param {string} coverageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccount(patientId: string, coverageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAccountResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccount(patientId, coverageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRAccountApi.createAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a guarantor refund amount
         * @param {string} guarantorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGuarantorRefund(guarantorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGuarantorRefund(guarantorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRAccountApi.deleteGuarantorRefund']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated accounts
         * @summary Get paginated accounts
         * @param {AccountSearch} accountSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccounts(accountSearch: AccountSearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccounts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccounts(accountSearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRAccountApi.getAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get account by a patient
         * @summary Get account by a patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountsByPatient(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccounts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountsByPatient(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRAccountApi.getAccountsByPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * paginated data for claims for an account
         * @summary Get paginated claims for an account
         * @param {string} accountId 
         * @param {ClaimSearch} claimSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimsByAccount(accountId: string, claimSearch: ClaimSearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountClaimsResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimsByAccount(accountId, claimSearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRAccountApi.getClaimsByAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get guarantor info on the basis of guarantor ID
         * @param {string} guarantorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGuarantor(guarantorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuarantorResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGuarantor(guarantorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRAccountApi.getGuarantor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch an account
         * @summary Patch an account
         * @param {string} accountId 
         * @param {AccountPatchModel} accountPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAccount(accountId: string, accountPatchModel: AccountPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAccount(accountId, accountPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRAccountApi.patchAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patch a Guarantor
         * @param {string} guarantorId 
         * @param {GuarantorFhirModel} guarantorFhirModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchGuarantor(guarantorId: string, guarantorFhirModel: GuarantorFhirModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchGuarantor(guarantorId, guarantorFhirModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRAccountApi.patchGuarantor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post a guarantor refund unallocated amount
         * @param {string} guarantorId 
         * @param {GuarantorRefundModel} guarantorRefundModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postGuarantorRefund(guarantorId: string, guarantorRefundModel: GuarantorRefundModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postGuarantorRefund(guarantorId, guarantorRefundModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRAccountApi.postGuarantorRefund']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search a Guarantor
         * @param {GuarantorSearch} guarantorSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchGuarantors(guarantorSearch: GuarantorSearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGuarantors200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchGuarantors(guarantorSearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRAccountApi.searchGuarantors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FHIRAccountApi - factory interface
 * @export
 */
export const FHIRAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FHIRAccountApiFp(configuration)
    return {
        /**
         * Create an account for primary claim filing
         * @summary Create an account for primary claim filing
         * @param {FHIRAccountApiCreateAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(requestParameters: FHIRAccountApiCreateAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostAccountResponseModel> {
            return localVarFp.createAccount(requestParameters.patientId, requestParameters.coverageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a guarantor refund amount
         * @param {FHIRAccountApiDeleteGuarantorRefundRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGuarantorRefund(requestParameters: FHIRAccountApiDeleteGuarantorRefundRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteGuarantorRefund(requestParameters.guarantorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated accounts
         * @summary Get paginated accounts
         * @param {FHIRAccountApiGetAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts(requestParameters: FHIRAccountApiGetAccountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAccounts200Response> {
            return localVarFp.getAccounts(requestParameters.accountSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get account by a patient
         * @summary Get account by a patient
         * @param {FHIRAccountApiGetAccountsByPatientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsByPatient(requestParameters: FHIRAccountApiGetAccountsByPatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAccounts200Response> {
            return localVarFp.getAccountsByPatient(requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * paginated data for claims for an account
         * @summary Get paginated claims for an account
         * @param {FHIRAccountApiGetClaimsByAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimsByAccount(requestParameters: FHIRAccountApiGetClaimsByAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccountClaimsResponseModel> {
            return localVarFp.getClaimsByAccount(requestParameters.accountId, requestParameters.claimSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get guarantor info on the basis of guarantor ID
         * @param {FHIRAccountApiGetGuarantorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuarantor(requestParameters: FHIRAccountApiGetGuarantorRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuarantorResponseModel> {
            return localVarFp.getGuarantor(requestParameters.guarantorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch an account
         * @summary Patch an account
         * @param {FHIRAccountApiPatchAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccount(requestParameters: FHIRAccountApiPatchAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchAccount(requestParameters.accountId, requestParameters.accountPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch a Guarantor
         * @param {FHIRAccountApiPatchGuarantorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGuarantor(requestParameters: FHIRAccountApiPatchGuarantorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchGuarantor(requestParameters.guarantorId, requestParameters.guarantorFhirModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post a guarantor refund unallocated amount
         * @param {FHIRAccountApiPostGuarantorRefundRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGuarantorRefund(requestParameters: FHIRAccountApiPostGuarantorRefundRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postGuarantorRefund(requestParameters.guarantorId, requestParameters.guarantorRefundModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search a Guarantor
         * @param {FHIRAccountApiSearchGuarantorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGuarantors(requestParameters: FHIRAccountApiSearchGuarantorsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchGuarantors200Response> {
            return localVarFp.searchGuarantors(requestParameters.guarantorSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FHIRAccountApi - interface
 * @export
 * @interface FHIRAccountApi
 */
export interface FHIRAccountApiInterface {
    /**
     * Create an account for primary claim filing
     * @summary Create an account for primary claim filing
     * @param {FHIRAccountApiCreateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApiInterface
     */
    createAccount(requestParameters: FHIRAccountApiCreateAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostAccountResponseModel>;

    /**
     * 
     * @summary Delete a guarantor refund amount
     * @param {FHIRAccountApiDeleteGuarantorRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApiInterface
     */
    deleteGuarantorRefund(requestParameters: FHIRAccountApiDeleteGuarantorRefundRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get paginated accounts
     * @summary Get paginated accounts
     * @param {FHIRAccountApiGetAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApiInterface
     */
    getAccounts(requestParameters: FHIRAccountApiGetAccountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAccounts200Response>;

    /**
     * Get account by a patient
     * @summary Get account by a patient
     * @param {FHIRAccountApiGetAccountsByPatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApiInterface
     */
    getAccountsByPatient(requestParameters: FHIRAccountApiGetAccountsByPatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAccounts200Response>;

    /**
     * paginated data for claims for an account
     * @summary Get paginated claims for an account
     * @param {FHIRAccountApiGetClaimsByAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApiInterface
     */
    getClaimsByAccount(requestParameters: FHIRAccountApiGetClaimsByAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccountClaimsResponseModel>;

    /**
     * 
     * @summary Get guarantor info on the basis of guarantor ID
     * @param {FHIRAccountApiGetGuarantorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApiInterface
     */
    getGuarantor(requestParameters: FHIRAccountApiGetGuarantorRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuarantorResponseModel>;

    /**
     * Patch an account
     * @summary Patch an account
     * @param {FHIRAccountApiPatchAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApiInterface
     */
    patchAccount(requestParameters: FHIRAccountApiPatchAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Patch a Guarantor
     * @param {FHIRAccountApiPatchGuarantorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApiInterface
     */
    patchGuarantor(requestParameters: FHIRAccountApiPatchGuarantorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Post a guarantor refund unallocated amount
     * @param {FHIRAccountApiPostGuarantorRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApiInterface
     */
    postGuarantorRefund(requestParameters: FHIRAccountApiPostGuarantorRefundRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Search a Guarantor
     * @param {FHIRAccountApiSearchGuarantorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApiInterface
     */
    searchGuarantors(requestParameters: FHIRAccountApiSearchGuarantorsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchGuarantors200Response>;

}

/**
 * Request parameters for createAccount operation in FHIRAccountApi.
 * @export
 * @interface FHIRAccountApiCreateAccountRequest
 */
export interface FHIRAccountApiCreateAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRAccountApiCreateAccount
     */
    readonly patientId: string

    /**
     * 
     * @type {string}
     * @memberof FHIRAccountApiCreateAccount
     */
    readonly coverageId: string
}

/**
 * Request parameters for deleteGuarantorRefund operation in FHIRAccountApi.
 * @export
 * @interface FHIRAccountApiDeleteGuarantorRefundRequest
 */
export interface FHIRAccountApiDeleteGuarantorRefundRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRAccountApiDeleteGuarantorRefund
     */
    readonly guarantorId: string
}

/**
 * Request parameters for getAccounts operation in FHIRAccountApi.
 * @export
 * @interface FHIRAccountApiGetAccountsRequest
 */
export interface FHIRAccountApiGetAccountsRequest {
    /**
     * 
     * @type {AccountSearch}
     * @memberof FHIRAccountApiGetAccounts
     */
    readonly accountSearch: AccountSearch

    /**
     * 
     * @type {number}
     * @memberof FHIRAccountApiGetAccounts
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRAccountApiGetAccounts
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getAccountsByPatient operation in FHIRAccountApi.
 * @export
 * @interface FHIRAccountApiGetAccountsByPatientRequest
 */
export interface FHIRAccountApiGetAccountsByPatientRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRAccountApiGetAccountsByPatient
     */
    readonly patientId: string
}

/**
 * Request parameters for getClaimsByAccount operation in FHIRAccountApi.
 * @export
 * @interface FHIRAccountApiGetClaimsByAccountRequest
 */
export interface FHIRAccountApiGetClaimsByAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRAccountApiGetClaimsByAccount
     */
    readonly accountId: string

    /**
     * 
     * @type {ClaimSearch}
     * @memberof FHIRAccountApiGetClaimsByAccount
     */
    readonly claimSearch: ClaimSearch

    /**
     * 
     * @type {number}
     * @memberof FHIRAccountApiGetClaimsByAccount
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRAccountApiGetClaimsByAccount
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getGuarantor operation in FHIRAccountApi.
 * @export
 * @interface FHIRAccountApiGetGuarantorRequest
 */
export interface FHIRAccountApiGetGuarantorRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRAccountApiGetGuarantor
     */
    readonly guarantorId: string
}

/**
 * Request parameters for patchAccount operation in FHIRAccountApi.
 * @export
 * @interface FHIRAccountApiPatchAccountRequest
 */
export interface FHIRAccountApiPatchAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRAccountApiPatchAccount
     */
    readonly accountId: string

    /**
     * 
     * @type {AccountPatchModel}
     * @memberof FHIRAccountApiPatchAccount
     */
    readonly accountPatchModel: AccountPatchModel
}

/**
 * Request parameters for patchGuarantor operation in FHIRAccountApi.
 * @export
 * @interface FHIRAccountApiPatchGuarantorRequest
 */
export interface FHIRAccountApiPatchGuarantorRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRAccountApiPatchGuarantor
     */
    readonly guarantorId: string

    /**
     * 
     * @type {GuarantorFhirModel}
     * @memberof FHIRAccountApiPatchGuarantor
     */
    readonly guarantorFhirModel: GuarantorFhirModel
}

/**
 * Request parameters for postGuarantorRefund operation in FHIRAccountApi.
 * @export
 * @interface FHIRAccountApiPostGuarantorRefundRequest
 */
export interface FHIRAccountApiPostGuarantorRefundRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRAccountApiPostGuarantorRefund
     */
    readonly guarantorId: string

    /**
     * 
     * @type {GuarantorRefundModel}
     * @memberof FHIRAccountApiPostGuarantorRefund
     */
    readonly guarantorRefundModel: GuarantorRefundModel
}

/**
 * Request parameters for searchGuarantors operation in FHIRAccountApi.
 * @export
 * @interface FHIRAccountApiSearchGuarantorsRequest
 */
export interface FHIRAccountApiSearchGuarantorsRequest {
    /**
     * 
     * @type {GuarantorSearch}
     * @memberof FHIRAccountApiSearchGuarantors
     */
    readonly guarantorSearch: GuarantorSearch

    /**
     * 
     * @type {number}
     * @memberof FHIRAccountApiSearchGuarantors
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRAccountApiSearchGuarantors
     */
    readonly pgSize?: number
}

/**
 * FHIRAccountApi - object-oriented interface
 * @export
 * @class FHIRAccountApi
 * @extends {BaseAPI}
 */
export class FHIRAccountApi extends BaseAPI implements FHIRAccountApiInterface {
    /**
     * Create an account for primary claim filing
     * @summary Create an account for primary claim filing
     * @param {FHIRAccountApiCreateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApi
     */
    public createAccount(requestParameters: FHIRAccountApiCreateAccountRequest, options?: RawAxiosRequestConfig) {
        return FHIRAccountApiFp(this.configuration).createAccount(requestParameters.patientId, requestParameters.coverageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a guarantor refund amount
     * @param {FHIRAccountApiDeleteGuarantorRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApi
     */
    public deleteGuarantorRefund(requestParameters: FHIRAccountApiDeleteGuarantorRefundRequest, options?: RawAxiosRequestConfig) {
        return FHIRAccountApiFp(this.configuration).deleteGuarantorRefund(requestParameters.guarantorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated accounts
     * @summary Get paginated accounts
     * @param {FHIRAccountApiGetAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApi
     */
    public getAccounts(requestParameters: FHIRAccountApiGetAccountsRequest, options?: RawAxiosRequestConfig) {
        return FHIRAccountApiFp(this.configuration).getAccounts(requestParameters.accountSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get account by a patient
     * @summary Get account by a patient
     * @param {FHIRAccountApiGetAccountsByPatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApi
     */
    public getAccountsByPatient(requestParameters: FHIRAccountApiGetAccountsByPatientRequest, options?: RawAxiosRequestConfig) {
        return FHIRAccountApiFp(this.configuration).getAccountsByPatient(requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * paginated data for claims for an account
     * @summary Get paginated claims for an account
     * @param {FHIRAccountApiGetClaimsByAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApi
     */
    public getClaimsByAccount(requestParameters: FHIRAccountApiGetClaimsByAccountRequest, options?: RawAxiosRequestConfig) {
        return FHIRAccountApiFp(this.configuration).getClaimsByAccount(requestParameters.accountId, requestParameters.claimSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get guarantor info on the basis of guarantor ID
     * @param {FHIRAccountApiGetGuarantorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApi
     */
    public getGuarantor(requestParameters: FHIRAccountApiGetGuarantorRequest, options?: RawAxiosRequestConfig) {
        return FHIRAccountApiFp(this.configuration).getGuarantor(requestParameters.guarantorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch an account
     * @summary Patch an account
     * @param {FHIRAccountApiPatchAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApi
     */
    public patchAccount(requestParameters: FHIRAccountApiPatchAccountRequest, options?: RawAxiosRequestConfig) {
        return FHIRAccountApiFp(this.configuration).patchAccount(requestParameters.accountId, requestParameters.accountPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch a Guarantor
     * @param {FHIRAccountApiPatchGuarantorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApi
     */
    public patchGuarantor(requestParameters: FHIRAccountApiPatchGuarantorRequest, options?: RawAxiosRequestConfig) {
        return FHIRAccountApiFp(this.configuration).patchGuarantor(requestParameters.guarantorId, requestParameters.guarantorFhirModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post a guarantor refund unallocated amount
     * @param {FHIRAccountApiPostGuarantorRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApi
     */
    public postGuarantorRefund(requestParameters: FHIRAccountApiPostGuarantorRefundRequest, options?: RawAxiosRequestConfig) {
        return FHIRAccountApiFp(this.configuration).postGuarantorRefund(requestParameters.guarantorId, requestParameters.guarantorRefundModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search a Guarantor
     * @param {FHIRAccountApiSearchGuarantorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRAccountApi
     */
    public searchGuarantors(requestParameters: FHIRAccountApiSearchGuarantorsRequest, options?: RawAxiosRequestConfig) {
        return FHIRAccountApiFp(this.configuration).searchGuarantors(requestParameters.guarantorSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }
}

